import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function AddLabour() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", dailyRate: "" });
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [error, setError]       = useState("");
  const [showPass, setShowPass] = useState(false);

  const navItems = [
    { label: "Dashboard",  emoji: "🏠", path: "/carpenter/dashboard" },
    { label: "My Labours", emoji: "👷", path: "/carpenter/labours" },
    { label: "Add Labour", emoji: "➕", path: "/carpenter/add-labour", active: true },
    { label: "Attendance", emoji: "📋", path: "/carpenter/attendance" },
    { label: "Payments",   emoji: "💰", path: "/carpenter/payments" },
    { label: "Salary",     emoji: "💵", path: "/carpenter/salary" },
  ];

  const handleChange = (e) => {
    setError("");
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/labour/create", form);
      setSuccess(true);
      setForm({ name: "", email: "", password: "", dailyRate: "" });
      setTimeout(() => setSuccess(false), 3500);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  const fields = [
    { name: "name",      label: "Full Name",   type: "text",     placeholder: "e.g. Raju Kumar",    icon: "👤" },
    { name: "email",     label: "Email",       type: "email",    placeholder: "raju@gmail.com",      icon: "✉️" },
    { name: "dailyRate", label: "Daily Rate",  type: "number",   placeholder: "e.g. 500",            icon: "₹",  prefix: true },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes popIn  { from{opacity:0;transform:scale(0.9)} to{opacity:1;transform:scale(1)} }
        @keyframes checkDraw { from{stroke-dashoffset:40} to{stroke-dashoffset:0} }
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,0.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background 0.15s,color 0.15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .form-input { width:100%; padding:12px 14px; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; background:#FFF7ED; transition:border-color 0.2s,box-shadow 0.2s; }
        .form-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,0.1); }
        .form-input::placeholder { color:#A8A29E; }
        .form-input:disabled { opacity:0.6; cursor:not-allowed; }
        .success-banner { background:linear-gradient(135deg,#D1FAE5,#A7F3D0); border:1.5px solid #A7F3D0; border-radius:14px; padding:16px 20px; display:flex; align-items:center; gap:12px; animation:popIn 0.3s ease; }
        .error-banner  { background:#FEF2F2; border:1.5px solid #FECACA; border-radius:14px; padding:14px 18px; display:flex; align-items:center; gap:10px; animation:popIn 0.25s ease; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform 0.28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
      `}</style>

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", backgroundColor:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Carpenter Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map((n) => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`} onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"linear-gradient(135deg,#FEF3C7,#FFF7ED)", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🪚 Carpenter</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Manage your team</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        {/* RIGHT */}
        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6"  x2="21" y2="6"  stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>➕ Add Labour</span>
          </div>

          <main className="main-content" style={{ padding:"32px", flex:1, overflowY:"auto" }}>
            <div style={{ maxWidth:"560px", margin:"0 auto" }}>

              {/* Header */}
              <div style={{ marginBottom:"24px", animation:"fadeUp 0.35s ease both" }}>
                <div style={{ display:"flex", alignItems:"center", gap:"12px", marginBottom:"6px" }}>
                  <div style={{ width:"44px", height:"44px", borderRadius:"12px", background:"linear-gradient(135deg,#92400E,#D97706)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"22px" }}>➕</div>
                  <div>
                    <h1 style={{ fontSize:"22px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.4px" }}>Add New Labour</h1>
                    <p style={{ fontSize:"13px", color:"#A8A29E" }}>Create a labour account under your team</p>
                  </div>
                </div>
              </div>

              {/* Success */}
              {success && (
                <div className="success-banner" style={{ marginBottom:"20px" }}>
                  <div style={{ width:"36px", height:"36px", borderRadius:"50%", background:"#059669", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="40" strokeDashoffset="0" style={{ animation:"checkDraw 0.4s ease" }}/>
                    </svg>
                  </div>
                  <div>
                    <p style={{ fontSize:"14px", fontWeight:"700", color:"#065F46" }}>Labour created successfully! 🎉</p>
                    <p style={{ fontSize:"12px", color:"#059669", marginTop:"2px" }}>The new labour can now log in to the app.</p>
                  </div>
                </div>
              )}

              {/* Error */}
              {error && (
                <div className="error-banner" style={{ marginBottom:"20px" }}>
                  <span style={{ fontSize:"18px" }}>⚠️</span>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#DC2626" }}>{error}</p>
                </div>
              )}

              {/* Form Card */}
              <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"20px", padding:"28px", animation:"fadeUp 0.4s 0.05s ease both" }}>
                <form onSubmit={handleSubmit}>
                  <div style={{ display:"flex", flexDirection:"column", gap:"18px" }}>

                    {fields.map((f) => (
                      <div key={f.name}>
                        <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px", letterSpacing:"0.1px" }}>
                          {f.label} <span style={{ color:"#DC2626" }}>*</span>
                        </label>
                        <div style={{ position:"relative" }}>
                          {f.prefix && (
                            <span style={{ position:"absolute", left:"13px", top:"50%", transform:"translateY(-50%)", fontSize:"13px", fontWeight:"700", color:"#78716C", pointerEvents:"none" }}>₹</span>
                          )}
                          <input
                            className="form-input"
                            name={f.name}
                            type={f.type}
                            placeholder={f.placeholder}
                            value={form[f.name]}
                            onChange={handleChange}
                            required
                            disabled={loading}
                            min={f.name === "dailyRate" ? 1 : undefined}
                            style={{ paddingLeft: f.prefix ? "28px" : "14px" }}
                          />
                        </div>
                      </div>
                    ))}

                    {/* Password field */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        Password <span style={{ color:"#DC2626" }}>*</span>
                      </label>
                      <div style={{ position:"relative" }}>
                        <input
                          className="form-input"
                          name="password"
                          type={showPass ? "text" : "password"}
                          placeholder="Min. 6 characters"
                          value={form.password}
                          onChange={handleChange}
                          required
                          disabled={loading}
                          minLength={6}
                          style={{ paddingRight:"44px" }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPass(!showPass)}
                          style={{ position:"absolute", right:"12px", top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:"16px", padding:"4px" }}
                        >
                          {showPass ? "🙈" : "👁️"}
                        </button>
                      </div>
                    </div>

                    {/* Info note */}
                    <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:"10px", padding:"12px 14px", display:"flex", gap:"9px" }}>
                      <span style={{ fontSize:"15px", flexShrink:0 }}>💡</span>
                      <p style={{ fontSize:"12px", color:"#78350F", fontWeight:"500", lineHeight:"1.5" }}>
                        The labour will use this email and password to log in. Daily rate is used for salary calculation.
                      </p>
                    </div>

                    {/* Submit */}
                    <button
                      type="submit"
                      disabled={loading}
                      style={{ padding:"14px", background: loading ? "#E7E5E4" : "linear-gradient(135deg,#B45309,#D97706)", border:"none", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"15px", fontWeight:"800", color: loading ? "#A8A29E" : "#fff", cursor: loading ? "not-allowed" : "pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:"8px", letterSpacing:"-0.2px", transition:"opacity 0.2s", marginTop:"4px" }}
                    >
                      {loading ? (
                        <>
                          <span style={{ width:"18px", height:"18px", border:"2.5px solid #C4B5A4", borderTop:"2.5px solid #78716C", borderRadius:"50%", animation:"spin 0.7s linear infinite", display:"inline-block" }} />
                          Creating Labour…
                        </>
                      ) : "➕ Create Labour Account"}
                    </button>

                  </div>
                </form>
              </div>

              {/* Back link */}
              <button
                onClick={() => navigate("/carpenter/labours")}
                style={{ marginTop:"16px", background:"none", border:"none", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"600", color:"#78716C", cursor:"pointer", display:"flex", alignItems:"center", gap:"5px" }}
              >
                ← Back to Labour List
              </button>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}